import { render, staticRenderFns } from "./Adsets.vue?vue&type=template&id=68830f54&"
import script from "./Adsets.vue?vue&type=script&lang=js&"
export * from "./Adsets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports